import { Form, Formik, type FormikHelpers } from 'formik';
import { useGetProfileQuery, useUpdateProfileMutation } from '../user.api-slice';
import CustomTextInput from '../../../components/Form/custom-text-input';
import { Link } from 'react-router-dom';
import MyProfileReadonlyInfo from '../components/MyProfileReadonlyInfo';
import { ProfileSchema } from '../user.schema';
import { type ProfileUser } from '../../../common/types';
import RenderErrorBag from '../../../components/render-error-bag';
import { toast } from 'react-toastify';
import { useState } from 'react';

const MyProfile: React.FC = () => {
  const { data: profile } = useGetProfileQuery();
  const [updateMyProfile, { isLoading }] = useUpdateProfileMutation();

  const [errorBag] = useState<string[]>([]);

  const handleUpdateProfile = async (values: ProfileUser, actions: FormikHelpers<ProfileUser>): Promise<any> => {
    await updateMyProfile({ body: values });
    toast('Profile is successfully updated');
  };

  return (
    <div className="mx-auto max-w-2xl py-8 px-8 my-8 rounded-md flex flex-col items-start bg-gray-50 min-h-[70vh]">
      <div className="w-full flex justify-center items-center">
        <span className="w-full h-full text-2xl">Edit Profile</span>
      </div>
      <div className="w-full flex flex-col items-start px-2 mt-4">
        {errorBag.length > 0 && <RenderErrorBag errorBag={errorBag} />}
        {profile != null && (
          <Formik initialValues={profile} onSubmit={handleUpdateProfile} validationSchema={ProfileSchema}>
            {({ isSubmitting }) => (
              <Form className="w-full flex flex-col items-start space-y-2" autoComplete="off">
                <CustomTextInput
                  type="text"
                  label="Fullname"
                  name="fullname"
                  divClass="w-full flex flex-col "
                  labelClass="w-full text-left text-gray-600"
                  inputClass="w-full my-1 px-4 py-1 rounded-md"
                />
                <MyProfileReadonlyInfo label="Email" type="text" value={profile.email} />
                <MyProfileReadonlyInfo label="Activation Status" type="boolean" value={profile.isActive} />
                <MyProfileReadonlyInfo label="Approved" type="boolean" value={profile.isApproved} />
                <div className="w-full flex space-x-2 mt-4">
                  <button
                    type="submit"
                    disabled={isLoading || isSubmitting}
                    className="w-1/2 text-white px-4 py-2 rounded-lg bg-[#1D8A43]"
                  >
                    Submit
                  </button>
                  <Link to="/admin" className="w-1/2">
                    <button className="w-full text-black ml-4 px-5 py-2 rounded-lg bg-gray-200">Cancel</button>
                  </Link>
                </div>
              </Form>
            )}
          </Formik>
        )}
      </div>
    </div>
  );
};

export default MyProfile;
